
import React from 'react';

interface ParticipantNameTagProps {
  name: string;
  role: string;
  isMuted: boolean;
}

const ParticipantNameTag: React.FC<ParticipantNameTagProps> = ({ name, role, isMuted }) => {
  return (
    <div className="absolute bottom-0 left-0 right-0 bg-black/50 backdrop-blur-sm p-2 flex items-center justify-between z-30">
      <div>
        <p className="text-sm font-medium text-white truncate">{name}</p>
        <p className="text-xs text-white/70 truncate">{role}</p>
      </div>
      
      <div className="flex items-center gap-1">
        <div className="w-1 h-4 bg-green-500/20 rounded-full overflow-hidden">
          <div 
            className="w-full bg-green-500 rounded-full"
            style={{ 
              height: isMuted ? '0%' : '80%',
              transition: 'height 0.2s ease-in-out'
            }}
          />
        </div>
        <div className="w-1 h-4 bg-green-500/20 rounded-full overflow-hidden">
          <div 
            className="w-full bg-green-500 rounded-full"
            style={{ 
              height: isMuted ? '0%' : '60%',
              transition: 'height 0.2s ease-in-out'
            }}
          />
        </div>
        <div className="w-1 h-4 bg-green-500/20 rounded-full overflow-hidden">
          <div 
            className="w-full bg-green-500 rounded-full"
            style={{ 
              height: isMuted ? '0%' : '40%',
              transition: 'height 0.2s ease-in-out'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ParticipantNameTag;
